/* istanbul ignore file */
/* hook is 98% copied in over from react-use/useDebounce */
import { useEffect } from 'react';
import { useTimeoutFn } from 'react-use';

export type UseDebounceReturn = [() => boolean | null, () => void];

export const useDebounce = (
  callback: VoidFunction,
  ms = 0,
  deps: ReadonlyArray<unknown> = [],
): UseDebounceReturn => {
  const [isReady, cancel, reset] = useTimeoutFn(callback, ms);

  useEffect(() => {
    /*
      This part is the additional code; it ensures the hook is not immediately called when defined.
      For example, the following will not run the callback until the hook dependency argument becomes true:
      useDebounce(someCallback, 100, [someVariableThatIsFalseByDefault])
    */
    const canInvokeCallback = deps.map((d) => !!d).filter(Boolean).length;

    if (!canInvokeCallback) {
      cancel();
    } else {
      reset();
    }
  }, deps);

  return [isReady, cancel];
};
